<header class="flex items-center justify-between">
  <div>
    <div class="flex items-center gap-1 text-[11px] font-[400]">
      @for (crumb of breadcrumbs(); track crumb.label) {
        <a [routerLink]="crumb.url" class="text-placeholder-strong hover-text-primary cursor-pointer transition-colors">
          {{ crumb.label }}
        </a>
        <span class="text-placeholder-strong">/</span>
      }
      <a
        [routerLink]="pageTitleUrl()"
        class="text-primary hover-text-primary-hover cursor-pointer font-medium transition-colors">
        {{ pageTitle() }}
      </a>
    </div>
  </div>
</header>
